import { useEffect, useState } from "react";
import { cn } from "@/lib/utils";

/** "Updated 12 s ago". The ticking pauses while the tab is hidden, matching how polling pauses. */
export function PollingIndicator({
  updatedAt,
  fetching,
  className,
}: {
  updatedAt: number | null;
  fetching?: boolean;
  className?: string;
}) {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = window.setInterval(() => {
      if (document.visibilityState === "visible") setNow(Date.now());
    }, 5000);
    return () => window.clearInterval(id);
  }, []);
  if (!updatedAt) return null;
  const seconds = Math.max(0, Math.round((now - updatedAt) / 1000));
  const text = fetching
    ? "Updating…"
    : seconds < 5
      ? "Updated just now"
      : seconds < 60
        ? `Updated ${seconds} s ago`
        : `Updated ${Math.round(seconds / 60)} min ago`;
  return (
    <span className={cn("text-muted-foreground text-xs", className)} role="status" aria-live="off">
      {text}
    </span>
  );
}
